var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3867 4.04321C13.9632 4.61975 14.4205 5.30421 14.7326 6.05749C15.0446 6.81078 15.2052 7.61815 15.2052 8.4335C15.2052 9.24885 15.0446 10.0562 14.7326 10.8095C14.4205 11.5628 13.9632 12.2472 13.3867 12.8238M11.7344 6.21241C12.0489 6.52688 12.2983 6.90022 12.4685 7.31111C12.6387 7.72199 12.7263 8.16237 12.7263 8.60711C12.7263 9.05185 12.6387 9.49223 12.4685 9.90311C12.2983 10.314 12.0489 10.6873 11.7344 11.0018",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08501 4.04321C3.50847 4.61975 3.05113 5.30421 2.73911 6.05749C2.42709 6.81078 2.26649 7.61815 2.26649 8.4335C2.26649 9.24885 2.42709 10.0562 2.73911 10.8095C3.05113 11.5628 3.50847 12.2472 4.08501 12.8238M5.7373 6.21241C5.42283 6.52688 5.17337 6.90022 5.00318 7.31111C4.83298 7.72199 4.74539 8.16237 4.74539 8.60711C4.74539 9.05185 4.83298 9.49223 5.00318 9.90311C5.17337 10.314 5.42283 10.6873 5.7373 11.0018",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.07 8.65535C10.07 9.39173 9.47303 9.98869 8.73665 9.98869C8.00027 9.98869 7.40332 9.39173 7.40332 8.65535C7.40332 7.91898 8.00027 7.32202 8.73665 7.32202C9.47303 7.32202 10.07 7.91898 10.07 8.65535Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/LiveIcon.18abf1607dadce66932cfd805ecb9679.svg";
export { ForwardRef as ReactComponent };